import config from '../config';
import { datadogLogs } from '@datadog/browser-logs';
import { getDatadogTags } from './datadogConstants';

const AMAZON_CONNECT_LOG_PATTERN = /\[\d{4}-\d{2}-\d{2}T[\d:.]+Z]\s+\[\w+]/;

export function tagAmazonConnectLog(event: { message?: string; source?: string }): void {
  const logMessage = event.message || '';
  if (AMAZON_CONNECT_LOG_PATTERN.test(logMessage)) {
    event.source = 'amazon-connect';
  }
}

export function initializeDatadog(): void {
  if (datadogLogs.getInitConfiguration()) return;

  const { datadogClientToken, datadogEnv } = config;

  datadogLogs.init({
    clientToken: datadogClientToken,
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    service: 'browser/cato',
    sessionSampleRate: 100,
    env: datadogEnv,
    beforeSend: log => {
      tagAmazonConnectLog(log);
      return true;
    }
  });

  const datadogTags = getDatadogTags();

  datadogLogs.setGlobalContext({
    ...datadogLogs.getGlobalContext(),
    ...datadogTags
  });

  datadogLogs.logger.addTag('team', datadogTags.team);
  datadogLogs.logger.addTag('costcenter', datadogTags.costcenter);
  datadogLogs.logger.addTag('appgroup', datadogTags.appgroup);
  datadogLogs.logger.addTag('retention', datadogTags.retention);
}
